import React from 'react';
import { observer } from 'mobx-react-lite';
import { PlaceholderStatesBase } from '../PlaceholderStates/PlaceholderStatesBase';
import { GridState } from '../../state';
import { ToolbarCollectionBaseProps } from '../ToolbarCollection';
import { FiltersMap } from '@wix/bex-core';

export interface GridPlaceholderStatesProps<T, F extends FiltersMap>
  extends ToolbarCollectionBaseProps<T, F> {
  state: GridState<T, F>;
}

function _GridPlaceholderStates<T, F extends FiltersMap>(
  props: GridPlaceholderStatesProps<T, F>,
) {
  const { state, renderEmptyState, renderError, topNotification, children } =
    props;
  const { collection } = state;
  return (
    <PlaceholderStatesBase
      state={state.toolbar.multi}
      topNotification={
        typeof topNotification === 'function'
          ? () => topNotification({ query: collection.result.originQuery })
          : topNotification
      }
      renderEmptyState={
        renderEmptyState
          ? () => {
              const {
                result: { originQuery, hasAvailableItems },
              } = collection;
              return renderEmptyState({
                hasAvailableItems,
                query: originQuery,
              });
            }
          : undefined
      }
      renderError={renderError}
      loadingState={null}
    >
      {children}
    </PlaceholderStatesBase>
  );
}

export const GridPlaceholderStates = observer(_GridPlaceholderStates);
